<template>
    <div class="event-action-container mb-2 d-flex">
        <v-btn @click="handleButtonClick" color="secondary"> Add Video Files </v-btn>

        <v-btn v-if="$auth.role.includes('SuperAdmin')" color="secondary" @click="$emit('video-direct-add')"
            >Add Video Direct</v-btn
        >
    </div>
</template>

<script>
export default {
    props: {
        event: {
            type: Object,
            required: true,
        },
        service: {
            type: Object,
            required: true,
        },
    },
    methods: {
        handleButtonClick: function () {
            this.$router.push({ path: `/services/upload/${this.event.id}` });
        },
    },
};
</script>

<style lang="scss" scoped>
.event-action-container {
    background: #f8f8f8;
    margin-top: 2rem;
    padding: 1rem;
    display: flex;
    justify-content: center;
    gap: 12px;
}
</style>
